import React from "react";

const GettingStarted = () => (
  <div>
    <h1>Getting Started Placeholder</h1>
  </div>
);

export default GettingStarted;
